import store from 'config/store'
import { triggerEmailCapturedAPIEvent } from 'modules/api/events'
import { updateIdentity } from 'modules/identity'
import { reevaluateRoutingRules } from 'modules/targeting/routing'
import { pathOr } from 'ramda'
import { filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'utils/redux'

export const pushToChannelEpic = (action$, state$) => action$.pipe(
  ofType('PUSH_TO_CHANNEL'),
  tap(({ meta, payload }) => {
    const {
      clusterName,
      channelName,
      eventName,
    } = meta || {}

    if (eventName && clusterName && channelName) {
      const channel = pathOr(null, ['session', 'sockets', clusterName, 'channels', channelName], state$.value)
      // We have to verify that the channel exists because the channel
      // state is only synced to the ChatManager and not all parts of the Widget
      if (channel) {
        channel.push(eventName, payload)
      }
    }
  }),
  ignoreElements()
)

export const updateEndUserEmailEpic = (action$, state$) => action$.pipe(
  ofType('IDENTIFY_LEAD'),
  filter(() => store.name === 'controller'),
  tap(async ({ payload: { email } }) => {
    await updateIdentity({ email })
    triggerEmailCapturedAPIEvent({ email })
    reevaluateRoutingRules()
  }),
  ignoreElements()
)
